exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-badge {\n    display: inline-block;\n    padding: 3px 6px;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 4px;\n}\n\n.badge-warning {\n    background-color: rgba(242, 166, 84, 0.15);\n    color: #f2a654;\n    border: 1px solid #f2a654;\n}\n\n.badge-success {\n    background-color: rgba(76, 175, 80, 0.15);\n    color: #4caf50;\n    border: 1px solid #4caf50;\n}\n\n.badge-danger {\n    background-color: rgba(244, 67, 54, 0.15);\n    color: #f44336;\n    border: 1px solid #f44336;\n}\n\n.badge-default {\n    background-color: rgba(158, 158, 158, 0.15);\n    color: #9e9e9e;\n    border: 1px solid #9e9e9e;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/status-badge/status-badge.component.css
// module id = ../../../../../src/app/components/status-badge/status-badge.component.css
// module chunks = 3